module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "siteProfile"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "site_info site_name"
  }, [_vm._v(_vm._s(_vm.site.name))]), _vm._v(" "), _c('div', {
    staticClass: "site_info site_address"
  }, [_vm._v(_vm._s(_vm.site.address))]), _vm._v(" "), _c('div', {
    staticClass: "site_info site_contact"
  }, [_c('icon', {
    attrs: {
      "name": "user"
    }
  }), _vm._v(" " + _vm._s(_vm.site.contact_name))], 1), _vm._v(" "), _c('div', {
    staticClass: "site_info site_contact"
  }, [_c('icon', {
    attrs: {
      "name": "envelope"
    }
  }), _vm._v(_vm._s(_vm.site.contact_email))], 1), _vm._v(" "), _c('div', {
    staticClass: "site_info site_contact phone"
  }, [_c('icon', {
    attrs: {
      "name": "phone"
    }
  }), _vm._v(" " + _vm._s(_vm.site.contact_phone))], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panelheader"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Information")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77233c50","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SiteProfile.vue
// module id = 828
// module chunks = 4